export default __webpack_public_path__ + "static/media/user-default.f3a1d340.png";